import * as React from "react";

import CostForm from "../../../components/Forms/OtherContract/CostForm/FlowForm";

export default function OtherContractCostForm() {
  return <CostForm />;
}
